<div
  class="banner banner--{{ type }} banner--{{
    size
  }} flex flex-col gap-[4px] justify-start items-start"
  notDraggableContent
>
  <div class="flex flex-row gap-[8px] w-full h-full">
    <mat-icon class="banner__icon" *ngIf="icon"> info </mat-icon>
    <div class="banner__content">
      <p class="banner__title" *ngIf="title">
        {{ title }}
      </p>
      <div
        class="banner__description gap-[8px] flex flex-{{
          title || linkInNewLine ? 'col' : 'row'
        }} justify-between items-start"
      >
        <span>
          <ng-content></ng-content>
        </span>
        <div class="banner__link">
          <ng-content select="[link]"> </ng-content>
        </div>

        <a
          *ngIf="link && linkLabel; else localRedirect"
          class="banner__link"
          [href]="link"
          target="_blank"
          rel="noreferrer"
          [gtm]="linkGtm"
          [gtmAction]="linkGtmAction"
          [gtmCategory]="linkGtmCategory"
          >{{ linkLabel }}<mat-icon class="banner__link__icon">arrow_forward</mat-icon>
        </a>
        <ng-template #localRedirect>
          <a
            *ngIf="linkLabel"
            class="banner__link"
            [routerLink]="linkForRouter"
            [queryParams]="queryParams"
            (click)="onClick()"
            [gtm]="linkGtm"
            [gtmAction]="linkGtmAction"
            [gtmCategory]="linkGtmCategory"
            >{{ linkLabel }}<mat-icon class="banner__link__icon">arrow_forward</mat-icon>
          </a>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="banner__description">
    <ng-content select="[description]"> </ng-content>
  </div>
</div>
